import React, { useState, useEffect } from 'react';
import { Footer, Header } from './headerFooter';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { getHost } from './config';
import './custom.scss';




function HistoricalData() {

    const navigate = useNavigate();
    const [yearRange, setYearRange] = useState('');
    const [specialtyOptions, setSpecialtyOptions] = useState([]);
    const [specialty, setSpecialty] = useState('');
    const [data, setData] = useState(null);
    const [uniqueDates, setUniqueDates] = useState([]);
    const [uniqueLocations, setUniqueLocations] = useState([]);
    const [eidikiAgogi, setEidikiAgogi] = useState(false);
    const [loading, setLoading] = useState(false); // New loading state
    const token = localStorage.getItem('authToken');

    useEffect(() => {
        if (!token) {
            navigate('/', { replace: true });
        }
    }, [token, navigate]);

    const handleLogout = () => {
        // Clear the authToken from localStorage
        localStorage.removeItem('authToken');
        localStorage.setItem('logout-event', Date.now());

        // Redirect to the login page
        navigate('/', { replace: true });
    }

    useEffect(() => {
            if (yearRange) { // Fetch only if yearRange is selected
                const url = `${getHost()}/api/specialty-types?year_range=${yearRange}`;
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                })
                    .then(response => response.json())
                    .then(data => setSpecialtyOptions(data.results))
                    .catch(error => console.error('Error fetching specialties:', error));
            } else {
                setSpecialtyOptions([]); // Clear specialties when yearRange is not selected
            }
        }, [yearRange]); // Trigger fetch when yearRange changes

        const handleSubmit = () => {
            setLoading(true);
            const url = `${getHost()}/api/historical-data`;
            const requestBody = {
                year_range: yearRange,
                specialty: specialty,
                eidiki_agogi: eidikiAgogi
            };
    
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(requestBody),
            })
                .then(response => response.json())
                .then(data => {
                    setData(data.results);
                    const dates = new Set()
                    const locations = new Set();
                    data.results.forEach((item) => {
                        dates.add(item.date);
                        Object.keys(item.locations).forEach(location => {
                            locations.add(location);
                        });
                    });
                    setUniqueDates(Array.from(dates));
                    setUniqueLocations(
                        Array.from(locations)
                            .sort((a, b) => {
                                if (a === "Σύνολο") return 1;
                                if (b === "Σύνολο") return -1;
                                return a.localeCompare(b, "el"); // Optional: sort Greek strings properly
                            })
                    );
                })
                .catch(error => console.error('Error fetching data:', error))
                .finally(() => {
                    setLoading(false); // Hide loading indicator regardless of success/failure
                });
        };

    
    const isFormValid = yearRange !== '' && specialty !== '';
    return (
        <div id="root">
            <Header handleLogout={handleLogout}/>
            <main className='main-container'>
                    <Container className='custom-container historical-container'>
                    <Form.Group className="mb-3 pt-3" controlId="yearSelect.range">
                        <Form.Label className='custom-label'>Έτος:</Form.Label>
                        <Form.Select 
                            className="custom-form" 
                            value={yearRange} 
                            onChange={(e) => {
                                setYearRange(e.target.value);
                                setSpecialty("");
                                setData(null);
                            }}>
                            <option>Επιλέξτε...</option>
                            <option value="2022_2023">2022-2023</option>
                            <option value="2023_2024">2023-2024</option>
                            <option value="2024_2025">2024-2025</option>
                            <option value="2025_2026">2025-2026</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="yearSelect.specialty">
                        <Form.Label className='custom-label'>Ειδικότητα:</Form.Label>
                        <Form.Select className="custom-form" value={specialty} onChange={(e) => setSpecialty(e.target.value)} disabled={!yearRange}>
                            <option>Επιλέξτε...</option>
                            {specialtyOptions.length > 0 ? (
                                specialtyOptions
                                .slice() // Create a shallow copy of the array to avoid mutating the original
                                .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
                                .map((spec) => (
                                    <option key={spec} value={spec}>
                                        {spec}
                                    </option>
                                ))
                            ) : (
                                <option>No specialties available</option>
                            )}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="yearSelect.eidiki">
                        <Form.Label className='custom-label'>Ειδική Αγωγή:</Form.Label>
                        <Form.Select className="custom-form" value={eidikiAgogi.toString()} onChange={(e) => setEidikiAgogi(e.target.value === 'true')}>
                            <option value="false">Όχι</option>
                            <option value="true">Ναι</option>
                        </Form.Select>
                        </Form.Group>
                    <Button variant="secondary" type="submit" onClick={handleSubmit} disabled={!isFormValid}>Υποβολή</Button>
                    
                    {loading && (
                        <div className="text-center mt-3 mb-3">
                            <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                            </div>
                            <div>Φόρτωση αποτελεσμάτων...</div>
                        </div>
                    )}

                    {data && (
                        <>
                            <div className="d-flex align-items-center my-3">
                                <h3 className="text-center flex-grow-1 m-0">Αποτελέσματα</h3>
                            </div>
                            <div className='table-outer-wrapper'>
                                <div className="table-scroll-wrapper">
                                    <Table striped bordered hover className='table-primary'>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                {uniqueDates.map(date => (
                                                <th key={date}>{date}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {uniqueLocations.map(place => (
                                            <tr key={place} className="cell-wrap">
                                            <td>{place}</td>
                                            {uniqueDates.map(date => (
                                                <td key={date}>
                                                    {
                                                        data.find(item => item.date === date)?.locations[place] || 0
                                                    }
                                                </td>
                                            ))}
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </>
                            
                    )}
                    </Container>
            </main>

            <Footer />
        </div>
    );

}

export default HistoricalData;